import { HIGH_CONFIDENCE_MIN, MEDIUM_CONFIDENCE_MIN } from '../PulseOpportunitiesWidget.constants';
export const classifyConfidence = (confidence)=>{
    if (confidence >= HIGH_CONFIDENCE_MIN) return 'high';
    if (confidence >= MEDIUM_CONFIDENCE_MIN) return 'medium';
    return 'low';
};
